import Form from 'react-bootstrap/Form'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import QuestionEditor from '../../../components/_questions/QuestionEditor'

export default function QuestionBankQuestionEditor({
    show,
    isNew,
    questionData,
    subjects,
    topics,
    onDataChange,
    onClose,
    onSaveAndClose,
    onSaveAndNew,
    onRemove
}) {
    const t = useSelector(selectTranslations)

    const [subjectFilter, setSubjectFilter] = useState('')

    useEffect(() => {
        if (show) {
            const currentTopic = topics?.find(topic => topic.topic_id === questionData?.topic_id)
            setSubjectFilter(currentTopic?.subject_id || '')
        }
    }, [show])

    const filteredTopics = subjectFilter
        ? topics?.filter(topic => topic.subject_id === subjectFilter)
        : topics

    const handleSubjectFilterChange = (value) => {
        setSubjectFilter(value)
        const currentTopic = topics?.find(topic => topic.topic_id === questionData?.topic_id)
        if (value && currentTopic?.subject_id !== value) {
            onDataChange({ ...questionData, topic_id: '' })
        }
    }

    const handleTopicChange = (e) => {
        onDataChange({
            ...questionData,
            topic_id: e.target.value
        })
    }

    const topicSelector = (
        <div className="row mt-3">
            <div className="col-4">
                <Form.Group controlId="question_bank_subject">
                    <Form.Label>{t.question_bank.subject}</Form.Label>
                    <Form.Select className="minw-0" value={subjectFilter} onChange={(e) => handleSubjectFilterChange(e.target.value)}>
                        <option value="">{t.question_bank.all_subjects}</option>
                        {subjects?.map(s => (
                            <option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </div>
            <div className="col-4">
                <Form.Group controlId="question_bank_topic">
                    <Form.Label>{t.question_bank.topic}</Form.Label>
                    <Form.Select className="minw-0" value={questionData?.topic_id || ''} onChange={handleTopicChange}>
                        <option value="">{t.question_bank.select_topic}</option>
                        {filteredTopics?.map(topic => (
                            <option key={topic.topic_id} value={topic.topic_id}>{topic.topic_name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </div>
        </div>
    )

    return (
        <QuestionEditor
            show={show}
            is_new={isNew}
            questionData={questionData}
            handleDataChange={onDataChange}
            closeQuestion={onClose}
            updateQuestions={onSaveAndClose}
            removeQuestion={onRemove}
            addQuestion={onSaveAndNew}
            extraContent={topicSelector}
        />
    )
}
